module.exports = __webpack_public_path__ + "img/video.300a6b4c.svg";